import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Header as GetiHeader, useTheme } from "@geti/identidade-visual-react";
import { logout } from "../../Auth/auth";
import { usePermission } from "../../Auth/PermissionContext";
import { LuCalendar, LuFileText, LuLogIn } from "react-icons/lu";
import logoDefensoriaSc from "../../Assets/logo-defensoria-sc-branco.png";
import { PATH } from "../../PATH";
import styles from "./Header.module.css";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setTheme } = useTheme();
  const { isAdmin, clearPermission } = usePermission();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const isHome = location.pathname === "/";

  useEffect(() => {
    if (!isHome) {
      setTheme("light");
    }
  }, [isHome, setTheme]);

  if (location.pathname.includes("viewer") || location.pathname === "/login") {
    return null;
  }

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      clearPermission();
      logout(navigate);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const navItems = isAdmin
    ? [
        {
          href: "/status",
          label: "Agendar",
          icon: <LuCalendar size={20} />,
          onClick: () => navigate("/status"),
        },
        {
          href: "/",
          label: "Diários",
          icon: <LuFileText size={20} />,
          onClick: () => navigate("/"),
        },
      ]
    : [
        {
          href: "/login",
          label: "Entrar",
          icon: <LuLogIn size={20} />,
          onClick: () => navigate("/login"),
        },
      ];

  return (
    <div className={styles.headerWrapper}>
      <GetiHeader
        publicMode={!isAdmin}
        logoSrc={logoDefensoriaSc}
        logoHref={PATH.logoHref}
        navItems={navItems}
        onLogout={isAdmin ? handleLogout : undefined}
        logoutLoading={isLoggingOut}
        hideThemeToggle={!isHome}
      />
    </div>
  );
};

export default Header;
